import { datajs } from '../shared/utils';
import { Tab } from 'bootstrap';

export default class OfficeArchive {
	static init() {
		// Switch between list and map view
		const viewToggle = datajs('office-archive-view-toggle');
		if (viewToggle) {
			const triggerTabList = viewToggle.querySelectorAll('button');
			triggerTabList.forEach((triggerEl) => {
				const tabTrigger = new Tab(triggerEl);

				triggerEl.addEventListener('click', (event) => {
					event.preventDefault();
					tabTrigger.show();
				});
			});
		}
	}
}
